/* eslint-disable semi */
import validator from './validator';
import el from './el';

// アプリ固有の定義
import api from './api';
import pages from './pages';
import dialogs from './dialogs';

export default {
  validator,
  el,
  pages,
  dialogs,
  api,
  common: {
    app: {
      name: 'アットホームシステム',
      copyright: 'Copyright (C) Pietto At-home System All rights reserved.'
    },
    count: {
      prefix: '全',
      suffix: '件'
    },
    table: {
      row_num: '項番',
      row_num_width: '80',
      detail_button_col_width: '80'
    },
    suffix: {
      month: 'ヶ月',
      yen: '円'
    },
    format: {
      month: 'yyyy/MM',
      date: 'yyyy/MM/dd',
      datetime: 'yyyy/MM/dd HH:mm:ss'
    },
    badge: {
      error: ' ！ '
    },
    button: {
      add: '追加',
      search: '検索',
      refer: '参照',
      execute: '実行',
      detail: '詳細',
      regist: '登録',
      update: '更新',
      delete: '削除',
      select: '選択',
      cancel: '取消',
      clear: 'クリア',
      print: '印刷',
      csv: 'CSV',
      excel: 'EXCEL',
      upload: 'アップロード',
      download: 'ダウンロード',
      reload: 'リロード',
      back: '戻る',
      footer_regist: '新規登録'
    },
    notify: {
      success: {
        login: '受付番号を確認しました',
        logout: 'ログアウトしました',
        regist: '登録が完了しました',
        update: '更新が完了しました',
        delete: '削除が完了しました',
        execute: '処理が完了しました',
        cancel: '解除処理が完了しました',
        allocation: '引当処理が完了しました',
        download: 'ダウンロードが完了しました'
      },
      error: {
        validation: '入力内容を確認してください',
        regist: '登録できませんでした',
        update: '更新できませんでした',
        delete: '削除できませんでした'
      }
    },
    confirm: {
      regist: '登録します、よろしいですか?',
      update: '更新します、よろしいですか?',
      delete: '削除します、よろしいですか?'
    },
    header: {
      login: 'ログイン',
      logout: 'ログアウト',
      profile: 'プロフィール編集'
    },
    word: {
      from: 'から',
      month: 'ヶ月',
      deliminator: '・',
      processed: '処理済',
      unprocessed: '未処理'
    }
  }
};



// WEBPACK FOOTER //
// ./src/lang/locales/ja/index.js